import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=e6ae3458&scoped=true"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"
import style0 from "./PopupContent.vue?vue&type=style&index=0&id=e6ae3458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae3458",
  null
  
)

export default component.exports